// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";

// Base Module
import ModuleBase from "#/common/ModuleBase";

// Components
import { Observer } from "mobx-vue";
import { BodyBuilder } from "../../../common/interfaces/conversionworld/BodyBuilder";
import { ContentModule } from "../../common/content_module/ContentModule";
import { reaction } from "mobx";
import ModuleWrapper from "../../../components/module_wrapper/ModuleWrapper";

@Observer
@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
  },
})
export class ProductTechnicalData extends ModuleBase {
  getBackgroundColorFromInstance(instance: object): string {
    return "black";
  }

  get currentProduct() {
    return this.$store.conversionWorldProduct.current;
  }

  get bodyWeight() {
    if (this.currentProduct) {
      return this.currentProduct.technical_data.body_weight;
    }
    return "";
  }

  get bodyHeight() {
    if (this.currentProduct) {
      return this.currentProduct.technical_data.body_height;
    }
    return "";
  }

  get bodyWidth() {
    if (this.currentProduct) {
      return this.currentProduct.technical_data.body_width;
    }
    return "";
  }

  get bodyDepth() {
    if (this.currentProduct) {
      return this.currentProduct.technical_data.body_depth;
    }
    return "";
  }

  get cabType() {
    if (this.currentProduct) {
      return this.currentProduct.technical_data.cab_type;
    }
    return "";
  }

  get roofType() {
    if (this.currentProduct) {
      return this.currentProduct.technical_data.roof_type;
    }
    return "";
  }

  get wheelbase() {
    if (this.currentProduct) {
      return this.currentProduct.technical_data.wheelbase;
    }
    return "";
  }

  get driveType() {
    if (this.currentProduct) {
      return this.currentProduct.technical_data.drive_type;
    }
    return "";
  }

  get steeringType() {
    if (this.currentProduct) {
      return this.currentProduct.technical_data.steering_type;
    }
    return "";
  }

  get grossWeight() {
    if (this.currentProduct) {
      return this.currentProduct.technical_data.gross_weight;
    }
    return "";
  }

  get modelSeries() {
    if (this.currentProduct) {
      return this.currentProduct.technical_data.model_series;
    }
    return "";
  }

  get variant() {
    if (this.currentProduct) {
      return this.currentProduct.technical_data.variant;
    }
    return "";
  }
}
